export class Status {
  constructor(
    public readonly enabled: boolean,
    public readonly isDeleted: boolean,
  ) {
  }
}
